<template>
  <main-layout>
    <p>404 Not found!</p>
  </main-layout>
</template>

<script>
import MainLayout from '../layouts/MainLayout'
export default {
  components: {
    MainLayout
  }
}
</script>